module.exports = __webpack_public_path__ + "efaa9d3bf4690f783f7a17f1381e2fef.fbx";